import * as Diagram from "../../../../components/diagram";

export const FundusChecklist = {
  label: "眼底鏡檢查清單",
  key: "FundusChecklist",
  path: "FundusAbnormal/FundusChecklist",
  api: "TCS_V_EyesCaseVisit",
  render: (options) => <Diagram.FundusAbnormal.FundusChecklist {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "居住鄉鎮", type: "string" },
    { key: "案件狀態", type: "string" },
  ],
  columns: [
    {
      key: "編號",
      field: "編號",
      header: "編號",
    },
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "居住鄉鎮",
      field: "居住鄉鎮",
      header: "居住鄉鎮",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
    {
      key: "個案姓名",
      field: "個案姓名",
      header: "個案姓名",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "地址",
      field: "地址",
      header: "地址",
    },
    {
      key: "電話",
      field: "電話",
      header: "電話",
    },
    {
      key: "手機",
      field: "手機",
      header: "手機",
    },
    {
      key: "建案日期",
      field: "建案日期",
      header: "建案日期",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
    {
      key: "ai轉介",
      field: "ai轉介",
      header: "ai轉介",
    },
    {
      key: "醫師轉介",
      field: "醫師轉介",
      header: "醫師轉介",
    },
    {
      key: "裸視左",
      field: "裸視左",
      header: "裸視左",
    },
    {
      key: "裸視右",
      field: "裸視右",
      header: "裸視右",
    },
    {
      key: "矯正左",
      field: "矯正左",
      header: "矯正左",
    },
    {
      key: "矯正右",
      field: "矯正右",
      header: "矯正右",
    },
    {
      key: "眼壓左",
      field: "眼壓左",
      header: "眼壓左",
    },
    {
      key: "眼壓右",
      field: "眼壓右",
      header: "眼壓右",
    },
    {
      key: "檢查結果",
      field: "檢查結果",
      header: "檢查結果",
    },
    {
      key: "非增值性視網膜病變",
      field: "非增值性視網膜病變",
      header: "非增值性視網膜病變",
    },
    {
      key: "增值性視網膜病變",
      field: "增值性視網膜病變",
      header: "增值性視網膜病變",
    },
    {
      key: "前增值性視網膜病變",
      field: "前增值性視網膜病變",
      header: "前增值性視網膜病變",
    },
    {
      key: "黃斑部水腫",
      field: "黃斑部水腫",
      header: "黃斑部水腫",
    },
    {
      key: "虹膜上新生血管青光眼",
      field: "虹膜上新生血管青光眼",
      header: "虹膜上新生血管青光眼",
    },
    {
      key: "青光眼",
      field: "青光眼",
      header: "青光眼",
    },
    {
      key: "會影響視力隻白內臟",
      field: "會影響視力隻白內臟",
      header: "會影響視力隻白內臟",
    },
    {
      key: "視網膜破洞引起的飛蚊症",
      field: "視網膜破洞引起的飛蚊症",
      header: "視網膜破洞引起的飛蚊症",
    },
    {
      key: "其他",
      field: "其他",
      header: "其他",
    },
    {
      key: "追蹤項目",
      field: "追蹤項目",
      header: "追蹤項目",
    },
  ],
};
